import * as types from '../types';
import jwtDecode, { JwtPayload } from 'jwt-decode';

  const initialState = {
    tokenData: null,
    error: false,
    loading: false,
    errorInfo: null,
    // token: JSON.parse(localStorage.getItem('token') || '{}'),
    hasActiveSession: null,
    userToken: JSON.parse(localStorage.getItem('decoded') || '{}'),
  };
  
  const tokenReducer = (state = initialState, action:any) => {
    const { type, payload, message } = action;
    
    switch (type) {
      case types.SEND_TOKEN_BEGIN:
        return {
          ...state,
          loading: true,
          token: null,
          error: null,
          tokenData: null,
          errorInfo: null,
          hasActiveSession: null,
        };

      case types.SEND_TOKEN_SUCCESS:
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        // localStorage.setItem("data", JSON.stringify(payload));
        const newtoken:string =  payload?.data?.accessToken;
        const theToken = localStorage.setItem("token", newtoken);
        const decoded = jwtDecode<JwtPayload>(newtoken);
        const activeSession = payload?.data?.hasActiveSession
        localStorage.setItem("decoded", JSON.stringify(decoded));
        return {
          ...state,
            tokenData: payload,
            error: false,
            errorInfo: null,
            loading: false,
            token: localStorage.getItem("token"),
            userToken: localStorage.getItem('decoded'),
            hasActiveSession: activeSession,
        };

      case types.SEND_TOKEN_FAILURE:
        return {
          ...state,
          tokenData: "{}",
          errorInfo: message,
          loading: false,
          error: true,
          hasActiveSession: null,
        };

        case types.RESET_TOKEN:
        return {
          ...state,
        }
      default:
        return state;
    }
  }

  export default tokenReducer;